module.exports = __webpack_public_path__ + "img/Apple_pay_icon.8f2bb7a9.png";